export const getApiUrl = (path: string): string => {
  const baseUrl = import.meta.env.VITE_API_URL || '';
  return `${baseUrl.replace(/\/$/, '')}${path}`;
};

export const fetchApi = async (path: string, init?: RequestInit): Promise<Response> => {
  const headers = new Headers(init?.headers);
  if (!headers.has('Authorization')) {
    headers.set('Authorization', 'Bearer ministry_super_admin_token');
  }
  if (!headers.has('x-tenant-slug')) {
    headers.set('x-tenant-slug', 'grace-church');
  }

  return fetch(getApiUrl(path), {
    ...init,
    headers,
  });
};


